import { render, staticRenderFns } from "./MENTION.vue?vue&type=template&id=700e9180"
import script from "./MENTION.vue?vue&type=script&lang=js"
export * from "./MENTION.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports